// Meta Pixel, loaded only when a Pixel ID is configured (see the meta-pixel-id tag in the
// layout, rendered only when META_PIXEL_ID is set - see Meta::ConversionsApi) and only after
// the visitor has accepted the cookie banner (reuses the same choice as Google Consent Mode,
// see cookie_consent_controller.js - one banner governs analytics and advertising alike).
// Everything else in the app calls window.SpicyPixel.track(...), never window.fbq directly.
const CONSENT_KEY = "spicy-cookie-consent-v1"

function consentGranted() {
  try {
    return window.localStorage.getItem(CONSENT_KEY) === "granted"
  } catch (error) {
    return false
  }
}

function loadPixelScript(pixelId) {
  if (window.fbq) return

  /* eslint-disable */
  !function(f,b,e,v,n,t,s){if(f.fbq)return;n=f.fbq=function(){n.callMethod?
  n.callMethod.apply(n,arguments):n.queue.push(arguments)};if(!f._fbq)f._fbq=n;
  n.push=n;n.loaded=!0;n.version='2.0';n.queue=[];t=b.createElement(e);t.async=!0;
  t.src=v;s=b.getElementsByTagName(e)[0];s.parentNode.insertBefore(t,s)}(window,
  document,'script','https://connect.facebook.net/en_US/fbevents.js')
  /* eslint-enable */

  window.fbq("init", pixelId)
}

function randomEventId() {
  return window.crypto?.randomUUID ? window.crypto.randomUUID() : `evt-${Date.now()}-${Math.random().toString(16).slice(2)}`
}

function track(name, params = {}, eventId = null) {
  if (!window.fbq) return
  window.fbq("track", name, params, { eventID: eventId || randomEventId() })
}

function start(pixelId) {
  if (!pixelId || !consentGranted()) {
    window.SpicyPixel = { track() {} }
    return
  }
  loadPixelScript(pixelId)
  window.fbq("track", "PageView")
  window.SpicyPixel = { track }
}

export function initMetaPixel() {
  const pixelId = document.querySelector('meta[name="meta-pixel-id"]')?.content
  window.SpicyPixel ||= { track() {} }

  // Turbo Drive swaps the body and keeps JS running across in-app navigations - it never
  // reloads this module, so PageView has to be re-fired from turbo:load (dispatched after
  // the first load too) rather than once here. loadPixelScript no-ops once fbq exists.
  document.addEventListener("turbo:load", () => start(pixelId))

  // The consent banner dispatches this on accept/decline - start (or confirm we stay off)
  // without needing a reload, and without this module knowing anything about the banner.
  document.addEventListener("spicy:consent-changed", () => start(pixelId))
}
